var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.687 4.23a.77.77 0 0 1 .55-.23H13.8c.204 0 .401.082.549.23.148.15.233.355.233.571v.802H9.454V4.8c0-.216.085-.42.233-.57M8.45 7.604h8.805v11.61a.8.8 0 0 1-.233.57.77.77 0 0 1-.549.231H7.565a.77.77 0 0 1-.55-.23.8.8 0 0 1-.232-.571V7.603zm-.995-2V4.8c0-.739.29-1.45.811-1.977A2.77 2.77 0 0 1 10.236 2H13.8c.741 0 1.45.298 1.97.824.521.527.812 1.238.812 1.977v.802h3.454a1 1 0 0 1 0 2h-.782v11.61c0 .74-.29 1.45-.81 1.977-.521.526-1.23.824-1.971.824h-8.91c-.74 0-1.45-.297-1.97-.824a2.8 2.8 0 0 1-.811-1.977V7.603H4a1 1 0 0 1 0-2zm3.782 5.504a1 1 0 1 0-2 0v5.404a1 1 0 0 0 2 0zm2.564-1a1 1 0 0 1 1 1v5.404a1 1 0 0 1-2 0v-5.404a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgDelete;